<tr #instance [id]="'FormSectionInstance:' + model.Id"  class="has_nest">
    <td *ngFor="let visibleLabel of labels; let i=index">
        <div>
            <ng-container *ngIf="i == 0">
                <div *ngIf="hasError; else participationStatus" class="section--status_icon">
                    <aurora-icon icon="warning"></aurora-icon>
                </div>
                <ng-template #participationStatus>
                    <div *ngIf="model.ParticipationStatus" class="section--status_icon">
                        <aurora-icon *ngIf="model.ParticipationStatus == 'Added'" icon="plus"></aurora-icon>
                        <aurora-icon *ngIf="model.ParticipationStatus == 'Changed'" icon="pencil"></aurora-icon>
                        <aurora-icon *ngIf="model.ParticipationStatus == 'Deleted'" icon="times"></aurora-icon>
                    </div>
                </ng-template>
            </ng-container>
            <div [ngClass]="{ 
                'value-added' : model.ParticipationStatus == 'Added',
                'value-deleted': model.ParticipationStatus == 'Deleted',
                'text-danger': formatNegatives(visibleLabel)
            }">
                <ng-container *ngIf="model.ParticipationStatus == 'Changed' && hasPreviousValue(visibleLabel); else normalRowValue">
                    <div class="value-added">
                        {{ getValueOfItemWithLabel(visibleLabel) }}
                    </div>
                    <div class="value-changed">
                        Previous: {{ getPreviousValueOfItemWithLabel(visibleLabel) }}
                    </div>
                </ng-container>
                <ng-container *ngIf="model.ParticipationStatus == 'Deleted'">
                    {{ getPreviousValueOfItemWithLabel(visibleLabel) }}
                </ng-container>
                <ng-template #normalRowValue>
                    <ng-container *ngIf="model.ParticipationStatus !== 'Deleted'">
                        {{ getValueOfItemWithLabel(visibleLabel) }}
                    </ng-container>
                </ng-template>
            </div>
        </div>
    </td>
    <td>
        <div class="table-row-actions">
            <aurora-icon-button 
                    *ngIf="readOnly"
                    [attr.id]="'FormSection:' + parentId + ':Instance' + model.Id + ':ViewInstance'"
                    icon="eye"
                    variant="ghost"
                    aria-label="View"
                    [ngbPopover]="sectionPopover"
                    popoverClass="popover-fit_content"
                    autoClose="'outside'"
                    container="body"
                    placement="left">
            </aurora-icon-button>
            <ng-template #sectionPopover>
                <div *ngFor="let element of getFieldsAndRows()" >
                    <sm-form-row *ngIf="element.ElementType == 'Row'" 
                        [model]="element" 
                        [readOnly]="true" 
                        [formState]="formState">
                    </sm-form-row>
                    <sm-form-field *ngIf="element.ElementType == 'Field'" 
                        [model]="element" 
                        [readOnly]="true" 
                        [formState]="formState">
                    </sm-form-field>
                </div> 
            </ng-template>
            <aurora-icon-button 
                    *ngIf="!readOnly && model.ParticipationStatus !== 'Deleted'" 
                    [attr.id]="'FormSection:' + parentId + ':Instance' + model.Id + ':EditInstance'"
                    icon="pencil"
                    variant="ghost"
                    aria-label="Edit"
                    (click)="openSectionInstance()">
            </aurora-icon-button>
            <aurora-icon-button 
                    *ngIf="!readOnly && model.ParticipationStatus !== 'Deleted' && model.Access != 'PreventAddAndDelete'" 
                    icon="trash"
                    variant="ghost"
                    aria-label="Delete"
                    [attr.id]="'FormSection:' + parentId + ':Instance' + model.Id + ':DeleteInstance'"
                    [ngbPopover]="deletePopover"
                    autoClose="true"
                    container="body"
                    placement="left">
            </aurora-icon-button>
            <ng-template #deletePopover>
                <div class="mb-2">
                    Deleting this will also delete all associated data, which may not be visible in the current application. Are you sure?
                </div>
                <div class="d-flex float-end mb-2">
                    <aurora-button 
                            id="ConfirmDelete" 
                            variant="secondary" 
                            (click)="onDeleteSelf()">
                        Delete
                    </aurora-button>
                    <aurora-button 
                            id="CancelDelete"
                            variant="ghost">
                        Cancel
                    </aurora-button>
                </div> 
            </ng-template>

            <aurora-icon-button 
                    *ngIf="!model.ToggledToHide && getChildrenSections()?.length" 
                    class="toggle" 
                    icon="chevron-up"
                    variant="ghost"
                    aria-label="Collapse nested sections"
                    (click)="model.ToggledToHide = true">
            </aurora-icon-button>
            <aurora-icon-button 
                    *ngIf="model.ToggledToHide && getChildrenSections()?.length" 
                    class="toggle" 
                    icon="chevron-down"
                    variant="ghost"
                    aria-label="Expand nested sections"
                    (click)="model.ToggledToHide = false">
            </aurora-icon-button>
        </div>
    </td>
</tr>    
<tr *ngIf="!model.ToggledToHide && getChildrenSections()?.length">
    <td [attr.colspan]="labels.length + 1" class="nest">
        <ng-container *ngFor="let innerSection of getChildrenSections()">
            <sm-form-section 
                [model]="innerSection" 
                [readOnly]="readOnly"
                [formState]="formState"
                (onValueChanged)="onValueChanged.emit($event)"
                (onSectionAdded)="onSectionAdded.emit($event)"
                (onSectionDeleted)="onSectionDeleted.emit($event)"
                (onDetectChanges)="updateStatuses()">
            </sm-form-section>
        </ng-container>
    </td> 
</tr>